<div class="card-shadow container-fluid">
    <form [formGroup]="baseForm">
        <h3 class="text-center p-4">Product Details</h3>
        <div class="ng-autocomplete form-group">
            <label for="title">Title</label>
            <ng-autocomplete id="title" formControlName="title" [data]="data" [searchKeyword]="keyword"
                (selected)='selectEvent($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>

            <ng-template #itemTemplate let-item>
                <a [innerHTML]="item.productTitle"></a>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
                <div [innerHTML]="notFound"></div>
            </ng-template>
        </div>
        <div class="form-group">
            <label for="auctionAmount">Auction Amount</label>
            <input type="number" class="form-control" formControlName="auctionAmount" id="auctionAmount" placeholder=""
                [readonly]="disableForm? true : null">
        </div>
        <div class="form-group">
            <label for="startsAt">Auction Starts at</label>

            <input class="form-control" formControlName="startsAt" id="startsAt" type="datetime-local"
                [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Start time"
                [readonly]="disableForm? true : null">
            <owl-date-time #dt1></owl-date-time>
        </div>
        <div class="form-group">
            <label for="endsAt">Auction Ends at</label>
            <input class="form-control" formControlName="endsAt" id="endsAt" type="datetime-local" [owlDateTime]="dt2"
                [owlDateTimeTrigger]="dt2" placeholder="End time" [readonly]="disableForm? true : null">
            <owl-date-time #dt2></owl-date-time>
        </div>
        <div class="form-group p-3">
            <button class="btn btn-primary float-right " [disabled]='baseForm.invalid' (click)="onNextClicked()">{{nextButtonText}}</button>
        </div>
    </form>
</div>